/**
 * P0-19: i18n 薄封装。
 *
 * 全局 $I 是运行时求值函数（i18n.js:188-190 → i18nLang.msg），
 * 换语言靠整页 reload（js/ui.js:771-776），无需响应式封装。
 * 本模块仅提供类型与测试 mock 便利；$I 缺失时回退为返回 key 本身。
 */

declare global {
  interface Window {
    $I?: (key: string, args?: unknown) => string;
  }
}

export function t(key: string, args?: unknown): string {
  const i18n = (globalThis as { $I?: Window["$I"] }).$I;
  if (typeof i18n !== "function") {
    return key;
  }
  return i18n(key, args);
}
